import React from 'react';
import { Checkbox } from 'rebass';
import styled from 'styled-components';
import { space } from 'styled-system';

const PvCheckmark = styled.span`
  opacity: ${props => props.disabled && '.5'};
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 2px solid ${props => props.color || props.theme.colors.green};
  border-radius: 4px;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;

const PvCheckboxWrapper = styled.label`
  ${space}
  width: 25px;
  height: 25px;
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  & input {
    top: 0;
    left: 0;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  ${PvCheckmark}:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const CustomCheckbox = styled(Checkbox)`
  &:hover ~ ${PvCheckmark} {
    background-color: #ccc;
  }
  &:checked ~ ${PvCheckmark} {
    background-color: ${props => props.color || props.theme.colors.green};
    border: none;
  }
  &:checked ~ ${PvCheckmark}:after {
    display: block;
  }
`;

export const PvCheckbox = (props) => (
  <PvCheckboxWrapper mr={props.mr}>
    <CustomCheckbox {...props} type='checkbox' />
    <PvCheckmark {...props} />
  </PvCheckboxWrapper>
);



// WEBPACK FOOTER //
// ./src/components/form/PvCheckbox.jsx